import React, { Component } from 'react';
import WeekBus from "./week_bus";
import "./week_model.css";

export default class WeekModel extends Component {
	constructor() {
		super();
		this.updateScroll = this.updateScroll.bind(this);
	}

	componentDidMount () {
		window["app-calendar"].addEventListener("scroll",this.updateScroll)
	}

	componentWillUnmount() {
		window["app-calendar"].removeEventListener("scroll",this.updateScroll)
	}

	updateScroll () {
		this.modelo.style.left = window["app-calendar"].scrollLeft+"px";
	}

	render() {
		let {id, name, external} = this.props;
		let buses = this.props.buses.map((bus)=>{
			return <WeekBus modelId={id} key={bus.name} {...bus} dates={this.props.dates} busDay={this.props.busDay} external={external}/>
		});
		return (
			<div className="app-modelo">
				<div className="modelo"
					 onClick={(()=>this.context.setOpenId("form-edit-model",{modelId: id}))}
					 ref={(ref)=>this.modelo = ref}
				>
					{name}
				</div>
				{buses}
			</div>
		)
	}
}
WeekModel.contextTypes = {
	setOpenId: React.PropTypes.func.isRequired,
	getOpenId: React.PropTypes.func.isRequired
};


/** WEBPACK FOOTER **
 ** ./src/components/week_model.js
 **/